import { render, staticRenderFns } from "./step_datos_vivienda.vue?vue&type=template&id=642a329a"
import script from "./step_datos_vivienda.vue?vue&type=script&lang=js"
export * from "./step_datos_vivienda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports